import {createSlice, PayloadAction} from "@reduxjs/toolkit";

export interface AppConfig {
    recaptchaKey: string;
    baseUrl: string;
    socketUrl: string;
    sessionUrl: string;
    tracker: string;
}

export enum AppView {
    Homepage
}

export interface MetaState {
    ready: boolean;
    settings: AppConfig;
    view: AppView;
    error: string | null;
}

const initialState: MetaState = {
    ready: false,
    error: null,
    settings: {
        recaptchaKey: "",
        baseUrl: "",
        socketUrl: "",
        sessionUrl: "",
        tracker: "",
    },
    view: AppView.Homepage
};

export const metaSlice = createSlice({
    name: "meta",
    initialState: initialState,
    reducers: {
        settings: (state, action: PayloadAction<AppConfig>) => {
            state.settings = action.payload;
            state.ready = true;
        },
        setError: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
        },
        clearError: (state) => {
            state.error = null;
        },
    }
});
